import type { IFuseOptions } from "fuse.js";
import type { EmojiEntry } from "./data";
import Fuse from "fuse.js";
import { emojiIndex } from "./data";

const options: IFuseOptions<EmojiEntry> = {
  threshold: 0.2,
  ignoreFieldNorm: true,
  keys: [
    { name: "shortCode", getFn: emoji => emoji.skins.map(skin => skin.shortCode) },
    { name: "id", getFn: emoji => emoji.id },
    { name: "name", getFn: emoji => emoji.name },
    { name: "keywords", getFn: emoji => emoji.keywords },
    { name: "aliases", getFn: emoji => emoji.aliases ?? [] },
    { name: "native", getFn: emoji => emoji.skins.map(skin => skin.native) },
  ],
  shouldSort: true,
};
export const searchIndex = new Fuse(emojiIndex.OrderedEmojis, options);
